import type { IconButtonProps } from '@mui/joy';
import { IconButton } from '@mui/joy';
import { createLink } from '@tanstack/react-router';
import { forwardRef } from 'react';

type IconButtonLinkProps = Omit<IconButtonProps<'a'>, 'component'> & {
  value?: string;
};

const UnwrappedIconButtonLink = forwardRef<HTMLAnchorElement, IconButtonLinkProps>(
  ({ key, ...props }: IconButtonLinkProps, ref) => <IconButton key={key} ref={ref} component="a" {...props} />,
);

export const IconButtonLink = createLink(UnwrappedIconButtonLink);
